import { AnimalEnemy, HumanEnemy } from './enemy';

const progress = context => Math.round((context.party.step / context.terrain.features.length) * 10) + 1;

const wolf = context => {
  const level = progress(context);
  const description = [
    'A pack hunter, its howl chills you to the bone.',
    'Cunning and relentless, working together to bring down prey.',
    'Hunting in the shadows, their eyes glint with hunger.',
    "A symbol of wilderness, a reminder of nature's power."
  ];
  return new AnimalEnemy({
    name: 'Wolf',
    level,
    description,
    health: 25, // 35
    attackPower: 15, // 20
    defense: 7, // 12
    speed: 60,
    agility: 70,
    intelligence: 50
  });
};

const bear = context => {
  const level = progress(context);
  const description = [
    'A hulking mass of fur and claws, the ground trembles with each step.',
    'An apex predator, its roar echoes through the mountains.',
    'Immense strength and a savage temper, a creature to be feared.',
    'Guarding its territory with ferocity, a challenge to all who dare enter.'
  ];
  return new AnimalEnemy({
    name: 'Bear',
    level,
    description,
    health: 50, // 60
    attackPower: 20, // 30
    defense: 10, // 15
    speed: 30,
    agility: 50,
    intelligence: 30
  });
};

const moose = context => {
  const level = progress(context);
  const description = [
    'majestic yet formidable, a giant among the forest',
    'a moose, with antlers like the boughs of ancient trees',
    'strength and endurance, a testament to the wild',
    'it stands, a silent sentinel of the northern woods'
  ];
  return new AnimalEnemy({
    name: 'Moose',
    level,
    description,
    health: 40, // 50
    attackPower: 15, // 20
    defense: 10, // 15
    speed: 20,
    agility: 30,
    intelligence: 20
  });
};

const elk = context => {
  const level = progress(context);
  const description = [
    'elegant and swift, the spirit of the forest',
    'an elk, its call a haunting melody at dusk',
    'grace and speed, its allies in the dance of survival',
    'a fleeting shadow among the trees, ever elusive'
  ];
  return new AnimalEnemy({
    name: 'Elk',
    level,
    description,
    health: 30, // 40
    attackPower: 10, // 15
    defense: 10, // 15
    speed: 40,
    agility: 50,
    intelligence: 30
  });
};

const cougar = context => {
  const level = progress(context);
  const description = [
    'silent whisper of death, a ghost in the twilight',
    'a cougar, its gaze piercing the veil of night',
    'stealth and power, the essence of a born predator',
    'in its domain, it reigns supreme, a shadow among shadows'
  ];
  return new AnimalEnemy({
    name: 'Cougar',
    level,
    description,
    health: 35, // 45
    attackPower: 18, // 25
    defense: 8, // 13
    speed: 80,
    agility: 80,
    intelligence: 60
  });
};

const snake = context => {
  const level = progress(context);
  const description = [
    'in the whisper of leaves, danger slithers silently',
    "a snake, embodiment of nature's quiet menace, awaits unseen",
    'venom and stealth, tools of a silent hunt',
    'its presence felt more in fear than sight, a ghost among the underbrush'
  ];
  return new AnimalEnemy({
    name: 'Snake',
    level,
    description,
    health: 10, // 15
    attackPower: 40, // Venom damage
    defense: 2, // 5
    speed: 40,
    agility: 90,
    intelligence: 40
  });
};

const bison = context => {
  const level = progress(context);
  const description = [
    'A thundering herd, the ground trembles beneath their hooves.',
    'Immense strength and a stubborn will, a force of nature.',
    'Guarding their young with ferocity, a challenge not to be taken lightly.',
    'An icon of the plains, their presence a testament to wild resilience.'
  ];
  return new AnimalEnemy({
    name: 'Bison',
    level,
    description,
    health: 45, // 55
    attackPower: 20, // 25
    defense: 12, // 17
    speed: 25,
    agility: 40,
    intelligence: 20
  });
};

const bandit = context => {
  const level = progress(context);
  const description = [
    'across the lawless expanses, fear and might crown their sovereign',
    'a bandit, ruler of realms cast in shadow, a tyranny born of desperation',
    'domination, a dark mantle worn with a grim resolve',
    'the world, its edges blurred, watches on'
  ];
  return new HumanEnemy({
    name: 'Bandit',
    level,
    description,
    health: 10,
    attackPower: 2,
    defense: 2,
    speed: 15,
    agility: 18
  });
};

const pirate = context => {
  const level = progress(context);
  const description = [
    'across the turbulent seas, their law is the only one that reigns',
    'a pirate, free and feared in the endless blue, a master of the waves',
    'greed and freedom, the sails of their soul',
    'the horizon, their promise of both fortune and peril'
  ];
  return new HumanEnemy({
    name: 'Pirate',
    level,
    description,
    health: 12,
    attackPower: 3,
    defense: 2,
    speed: 12,
    agility: 14
  });
};

const soldier = context => {
  const level = progress(context);
  const description = [
    'beneath the banners of forgotten lands, they march, unwavering',
    'a soldier, a pawn of empires, a carrier of causes not their own',
    'duty and honor, their shield and curse',
    'in the shadow of swords, they find their truth'
  ];
  return new HumanEnemy({
    name: 'Soldier',
    level,
    description,
    health: 20,
    attackPower: 4,
    defense: 5,
    speed: 8,
    agility: 10
  });
};

const native = context => {
  const level = progress(context);
  const description = [
    'within the heart of uncharted territories, they stand vigilant',
    'a native, guardian of secrets and sacred lands, whispers of the earth',
    'tradition and spirit, their path and guide',
    'against intrusion, they rise, as fierce as the land they call home'
  ];
  return new HumanEnemy({
    name: 'Native',
    level,
    description,
    health: 18,
    attackPower: 3,
    defense: 4,
    speed: 14,
    agility: 16
  });
};
const killer = context => {
  const level = progress(context);
  const description = [
    'shrouded in whispers of death, a specter among men',
    'a killer, walking the thin line between shadow and flesh',
    'precision and silence, their grim companions',
    'leaving a trail of whispers, they vanish like a mirage'
  ];
  return new HumanEnemy({
    name: 'Killer',
    level,
    description,
    health: 10,
    attackPower: 5,
    defense: 2,
    speed: 18,
    agility: 15
  });
};

const raider = context => {
  const level = progress(context);
  const description = [
    'where chaos thrives, their flags rise',
    "a raider, the storm's fury given form",
    'lust for plunder, a fire that burns without end',
    'in their wake, only the echoes of turmoil'
  ];
  return new HumanEnemy({
    name: 'Raider',
    level,
    description,
    health: 10,
    attackPower: 15,
    defense: 2,
    speed: 12,
    agility: 10
  });
};

const tribesman = context => {
  const level = progress(context);
  const description = [
    'born of the earth, guardian of the ancient ways',
    'a tribesman, spirit of the wild incarnate',
    'honor and fury, intertwined like roots',
    'a force as natural and relentless as the turning seasons'
  ];
  return new HumanEnemy({
    name: 'Tribesman',
    level,
    description,
    health: 14,
    attackPower: 8,
    defense: 5,
    speed: 13,
    agility: 14
  });
};

const outlaw = context => {
  const level = progress(context);
  const description = [
    'beyond the reach of law, where freedom and danger entwine',
    'an outlaw, shadow draped in defiance',
    'rebellion, a cloak worn with pride',
    'the horizon, a line forever pursued'
  ];
  return new HumanEnemy({
    name: 'Outlaw',
    level,
    description,
    health: 10,
    attackPower: 2,
    defense: 1,
    speed: 15,
    agility: 12
  });
};
const marshal = context => {
  const level = progress(context);
  return new HumanEnemy({
    name: 'Marshal',
    level,
    health: 45,
    attackPower: 10,
    defense: 4,
    speed: 10,
    agility: 14,
    description: [
      'the embodiment of law, unwavering and formidable',
      "a marshal, justice's sharp edge, feared by those who stray from the path",
      'authority and resolve, clad in a badge of honor',
      'in his gaze, the end of many a rogue'
    ]
  });
};

const deputy = context => {
  const level = progress(context);
  return new HumanEnemy({
    name: 'Deputy',
    level,
    health: 20,
    attackPower: 4,
    defense: 3,
    speed: 12,
    agility: 12,
    description: [
      'right hand of justice, ever vigilant and loyal',
      "a deputy, the law's keen sight, guardian of peace",
      'courage and duty, his companions in every shadow',
      'behind the badge, a resolve as strong as iron'
    ]
  });
};

const lawman = context => {
  const level = progress(context);
  return new HumanEnemy({
    name: 'Lawman',
    level,
    health: 22,
    attackPower: 4,
    defense: 3,
    speed: 11,
    agility: 13,
    description: [
      'a keeper of peace, his presence a deterrent to chaos',
      'a lawman, balance between order and freedom',
      'judgment and fairness, his guide through turmoil',
      'an oath to protect, a life devoted to service'
    ]
  });
};

const bountyHunter = context => {
  const level = progress(context);
  return new HumanEnemy({
    name: 'Bounty Hunter',
    level,
    health: 32,
    attackPower: 12,
    defense: 3,
    speed: 13,
    agility: 15,
    description: [
      "shadow of the wilds, where law's reach ends, he begins",
      "a bounty hunter, relentless tracker, fortune's fickle friend",
      'cunning and resolve, his path lit by the promise of gold',
      'alone against many, a testament to survival'
    ]
  });
};

const createEnemy = (type, context) => {
  switch (type) {
    case 'moose':
      return moose(context);
    case 'elk':
      return elk(context);
    case 'cougar':
      return cougar(context);
    case 'wolf':
      return wolf(context);
    case 'bear':
      return bear(context);
    case 'bison':
      return bison(context);
    case 'serpent':
    case 'snake':
      return snake(context);
    case 'bandit':
      return bandit(context);
    case 'pirate':
      return pirate(context);
    case 'soldier':
      return soldier(context);
    case 'native':
      return native(context);
    case 'killer':
      return killer(context);
    case 'raider':
      return raider(context);
    case 'tribesman':
      return tribesman(context);
    case 'outlaw':
      return outlaw(context);
    case 'lawman':
      return lawman(context);
    case 'deputy':
      return deputy(context);
    case 'bountyHunter':
      return bountyHunter(context);
    case 'marshal':
      return marshal(context);
    default:
      return wolf(context);
  }
};

const combatEvent = {
  isCombat: true
};

const createCombatEvent = (title, description, enemies, victory, defeat, context, setEvent) => {
  return {
    ...combatEvent,
    title,
    description,
    victory,
    defeat,
    enemies: enemies.map(enemy => createEnemy(enemy, context))
  };
};

export default createCombatEvent;
